interface IDelayedTimeout {
  current: {
    id: ReturnType<typeof setTimeout>;
    resolves: Array<() => void>;
  } | null;
}

const delayedCallback = async <T>(
  timeout: IDelayedTimeout,
  callback: () => Promise<T> | T
): Promise<T | void> => {
  if (timeout.current) {
    clearTimeout(timeout.current.id);
  }

  return new Promise<T | void>((resolve) => {
    const prevResolves = timeout.current ? timeout.current.resolves : [];

    const timeoutId = setTimeout(async () => {
      const callbackResult = await callback();

      prevResolves.forEach((prevResolve) => prevResolve());
      resolve(callbackResult);
    }, 300);

    timeout.current = {
      id: timeoutId,
      resolves: prevResolves.concat(resolve as () => void),
    };
  });
};

export type { IDelayedTimeout };
export { delayedCallback };
